import { atom } from "recoil";

export const supplierLists = atom({
  key: "supplierLists",
  default: [],
});
